module.exports = __webpack_public_path__ + "media/images/top/btn-skip-fff46d746fbf2c80fc46fc1211d94f87.svg";